import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { PropsWithClassName } from 'shared/props';
import styles from './FieldContainerComponent.module.scss'

export interface FieldContainerProps {
}
export const FieldContainerComponent = (props: PropsWithChildren<FieldContainerProps> & PropsWithClassName) => {
	return (
		<div className={classNames(styles.container, props.className)}>
			{props.children}
		</div>
	)
}